import React, { useEffect } from 'react';
import Header from '../../global/modules/ccaHeader/Header';
import { grHeaderShimmerEffect } from '../utils/shimmerUtil';
import { useGuidedRegContext } from '../context/guidedRegContext';
import { APPLICATION_ERROR, THANK_YOU } from '../cashFlow/constants';
import config from '../../App/config';
import { useAnalyticsContext } from '../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../constants/analyticsConstants/Ecommerce';
import { logGRError, navigateToPath } from '../utils/guidedUtil';
import { useNavigate } from 'react-router-dom';
import { STORAGE_CONFIG } from '../../../constants/storageConfig';

export default function GuidedRegHeader() {
    const [{ currentStepIndex }] = useGuidedRegContext();
    const navigate = useNavigate();
    const {
        pagePaths: { guidedRegWorkflow }
    } = config;
    const isHeaderBackExitHelpVisible =
        window.location.pathname.includes(`${THANK_YOU}`) || window.location.pathname.includes(`${APPLICATION_ERROR}`);
    const { sendEventsForGRModalOpened, sendEventsForModalClosed, sendEventsForGRModalCompleted } =
        useAnalyticsContext();

    useEffect(() => {
        grHeaderShimmerEffect();
    }, []);

    const modalOpenEvent = (eventName, form_name, form_type, form_error) => {
        sendEventsForGRModalOpened(eventName, form_name, form_type, form_error);
    };

    const modalCloseEvent = (eventName, link_name, link_type, link_location, link_destination) => {
        sendEventsForModalClosed(
            eventName,
            link_name,
            link_type,
            link_location,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CLOSE
        );
    };

    const completedAnalyticEvent = (modalType, label) =>
        sendEventsForGRModalCompleted(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_COMPLETED,
            `${EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL}-${modalType}`,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
            label,
            ''
        );

    const handleExitAccountCreationButtonClick = () => {
        try {
            let currentPath = window.location.pathname;
            // Ensure the currentPath ends with a '/'
            if (!currentPath.endsWith('/')) {
                currentPath = currentPath + '/';
            }
            if (currentPath == guidedRegWorkflow) {
                const storedReferer = sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.REFERER);
                if (!storedReferer) {
                    window.history?.back();
                } else {
                    window.location.replace(storedReferer);
                }
            } else {
                window.location.replace(`${window.location.origin}${guidedRegWorkflow}`);
            }
        } catch (error) {
            logGRError(error);
        }
    };

    const handleBackClick = () => {
        try {
            let currentPath = window.location.pathname;
            // Ensure the currentPath ends with a '/'
            if (!currentPath.endsWith('/')) {
                currentPath = currentPath + '/';
            }
            if (currentPath == guidedRegWorkflow) {
                const url = sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.REFERER);
                if (url?.indexOf('returnUrl=/') !== -1) {
                    const urlObject = new URL(url);
                    const params = new URLSearchParams(urlObject.search);
                    const returnUrl = params.get('returnUrl');

                    if (returnUrl) {
                        window.location.replace(`${window.location.origin}${returnUrl}`);
                        return;
                    }
                }
                window.location.replace(sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.REFERER));
            } else if (currentPath.includes(guidedRegWorkflow)) {
                navigateToPath(navigate);
            } else if (currentStepIndex != 0) {
                // this is for step-2 to step-1
                window?.history?.back();
            } else {
                window.location.replace(`${window.location.origin}${guidedRegWorkflow}`);
            }
        } catch (error) {
            logGRError(error);
        }
    };

    return (
        <>
            <Header
                onBackClick={handleBackClick}
                onExitClick={handleExitAccountCreationButtonClick}
                modalOpenEvent={modalOpenEvent}
                modalCloseEvent={modalCloseEvent}
                completedAnalyticEvent={completedAnalyticEvent}
                isHeaderBackExitHelpVisible={isHeaderBackExitHelpVisible}
            />
        </>
    );
}
